// extracted by mini-css-extract-plugin
module.exports = {"overlay":"ForceAcceptCgu_overlay__VxdpD","panel":"ForceAcceptCgu_panel__vPMnA","content":"ForceAcceptCgu_content__7jtqo","actions":"ForceAcceptCgu_actions__8zPAf"};